import AssetUploader from "./";
import validatable from "../hoc/validatable";

var ValidatableImageAssetUploader = function ValidatableImageAssetUploader(validators) {
  return validatable(validators)(AssetUploader.Image);
};

var ValidatableVideoAssetUploader = function ValidatableVideoAssetUploader(validators) {
  return validatable(validators)(AssetUploader.Video);
};

var ValidatableMediaAssetUploader = function ValidatableMediaAssetUploader(validators) {
  return validatable(validators)(AssetUploader.Media);
};

var ValidatableAssetUploader = {
  Image: ValidatableImageAssetUploader,
  Video: ValidatableVideoAssetUploader,
  Media: ValidatableMediaAssetUploader
};
export default ValidatableAssetUploader;
//# sourceMappingURL=validatable-asset-uploader.js.map